import { render, staticRenderFns } from "./orderReturn2.vue?vue&type=template&id=75ba83fd&"
import script from "./orderReturn2.vue?vue&type=script&lang=js&"
export * from "./orderReturn2.vue?vue&type=script&lang=js&"
import style0 from "./orderReturn2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports